import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.tsx';
import './index.css';
import { registerServiceWorker, initApnsTokenListener } from './lib/pushService';
import { initSentry } from './lib/sentry';

initSentry();
registerServiceWorker();
initApnsTokenListener();

// Vangnet voor verouderde sessies na een deploy (we rollen vaak uit): een
// lazy geladen stuk code ('chunk') bestaat dan niet meer op de server en de
// dynamic import krijgt HTML terug ("'text/html' is not a valid JavaScript
// MIME type"). Eén automatische verversing haalt de nieuwe versie op; de
// sessionStorage-guard voorkomt een ververslus als het iets anders is.
window.addEventListener('vite:preloadError', (event) => {
  if (sessionStorage.getItem('chunk-hersteld') === '1') return;
  sessionStorage.setItem('chunk-hersteld', '1');
  event.preventDefault();
  window.location.reload();
});
window.addEventListener('load', () => {
  // Geslaagde volledige load: de guard mag weer vrij voor een volgende deploy.
  setTimeout(() => sessionStorage.removeItem('chunk-hersteld'), 30_000);
});

// Vangnet tegen dubbel opstarten. Als deze entry-module ooit een tweede keer
// wordt uitgevoerd (casus Pieter 01-10-2026: een dynamic `import()` naar een
// module uit de entry-chunk kreeg door skew-protection een `?dpl=`-URL en
// laadde zo de hele app opnieuw, met een tweede React-root en een tweede
// React-Query-context → "No QueryClient set"), dan mounten we níet nog een
// keer. De build weigert zo'n import inmiddels (vite.config.ts), dit is de
// laatste verdedigingslinie in de browser.
const globaal = window as unknown as { __prachtAppGestart?: boolean };
if (globaal.__prachtAppGestart) {
  console.error('Pracht: entry-module werd een tweede keer geladen; tweede mount overgeslagen.');
} else {
  globaal.__prachtAppGestart = true;
  createRoot(document.getElementById('root')!).render(
    <StrictMode>
      <App />
    </StrictMode>,
  );
}
